import { TEST_SHOWCASE_IMG_PATH, PLACEHOLDER_IMG_SRC } from '../constants'

const GET_TESTS_API_URL = '/api/v1/tests'

$(document).ready(function () {
    const domLoading = $('#test-loading');
    const domPagination = $('#test-pagination');
    const domTemplate = $('#test-template');

    const DEFAULT_COLOR = '#4786C6';
    const DEFAULT_IMAGE_PATH = '/images/showcase/play/play-item-background-0.svg';

    let categoriesFilled = {
        recruitment: false,
        health: false,
        other: false
    };

    const insertTest = (test, category) => {
        const testColor = (test.test_color && test.test_color !== '#FFFFFF') ? test.test_color : DEFAULT_COLOR;
        const imagePath = test.image_path || DEFAULT_IMAGE_PATH;

        const template = domTemplate.contents().clone().appendTo(`#${category}-tests`);
        const anchor = template.find('a');
        anchor.attr('href', `/tests/${test.ref}/start`).attr('target', '_self');

        anchor.hover(
            function () {
                $(this).css('box-shadow', `0 0 13px 0px ${testColor}`);
            }
        );

        // Add box-shadow to anchor elements within the template if on mobile
        if ($(window).width() <= 768) {
            // Intersection Observer
            const observerOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 0.5
            };

            function observerCallback(entries, observer) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        $(entry.target).css('box-shadow', `0 0 13px 0px ${testColor}`);
                    } else {
                        $(entry.target).css('box-shadow', '');
                    }
                });
            };

            const observer = new IntersectionObserver(observerCallback, observerOptions);
            observer.observe(anchor[0]);
        };

        template.find('.background-img').attr('src', imagePath);
        template.find('.title').text(test.title).css('color', testColor);
        template.find('.test_description').text(test.sub_title).css('color', testColor);
        template.find('.test-title').text(test.title);
        template.find('.test-intro').text(test.sub_title);

        const tagLabel = template.find('.tag-label');
        if (test.tag_name) {
            tagLabel.text(test.tag_name);
            tagLabel.css('background-color', test.tag_color || '#ff3860');
            tagLabel.css('opacity', 1);
        } else {
            tagLabel.css('opacity', 0);
        }

        categoriesFilled[category] = true;
    }

    const createPagination = (pagesCount, currentPage = 1) => {
        for (let i = 1; i < pagesCount + 1; i++) {
            domPagination.find('ul').append(`
            <li>
                <a class="pagination-link ${i === currentPage ? 'is-current' : ''}">
                ${i}
                </a>
            </li>
            `);
        }
        domPagination.removeClass('is-hidden');

        $('.pagination-link').on('click', (event) => {
            const domElement = $(event.target);

            if (domElement.hasClass('is-current')) return;

            domPagination.find('a').removeClass('is-current');
            domElement.addClass('is-current');

            const pageTargeted = parseInt(domElement.text().trim());
            getTests(pageTargeted);
        });
    };

    const getTests = (page = 1) => {
        domLoading.fadeIn();
        $('#recruitment-tests, #health-tests, #other-tests').empty(); // Clear categories

        categoriesFilled = {
            recruitment: false,
            health: false,
            other: false
        };

        $.ajax({
            type: 'GET',
            url: GET_TESTS_API_URL + `?page=${page}&limit=9`,
            headers: {
                'X-App-Locale': window.locale || 'fr'
            },
            success: (response) => {
                domLoading.fadeOut(() => {
                    const pages = response.data.pages;
                    let tests = response.data.items;

                    // TODO: Currently sorting in front-end, but later we should implement the sorting of JSON data types in the 'DataList.php' file directly.
                    tests.sort((a, b) => a.title.localeCompare(b.title));

                    tests.forEach((test) => {
                        if (test.category === 'recruitment') {
                            insertTest(test, 'recruitment');
                        } else if (test.category === 'health') {
                            insertTest(test, 'health');
                        } else {
                            insertTest(test, 'other');
                        }
                    });

                    if (!categoriesFilled.recruitment) $('#recruitment-tests-container').hide();
                    else $('#recruitment-tests-container').show();

                    if (!categoriesFilled.health) $('#health-tests-container').hide();
                    else $('#health-tests-container').show();

                    if (!categoriesFilled.other) $('#other-tests-container').hide();
                    else $('#other-tests-container').show();

                    if (pages > 1 && domPagination.is(':hidden')) {
                        createPagination(pages);
                    }
                });
            },
            error: () => {
                domLoading.fadeOut();
            }
        });
    };

    getTests();
});

$(document).ready(function () {
    function updateColumnClass() {
        var column = document.getElementById('responsive-column');
        if (window.innerWidth < 1500) {
            column.className = 'column is-8';
        } else {
            column.className = 'column is-6 is-offset-1';
        }
    }

    updateColumnClass();

    window.addEventListener('resize', updateColumnClass);
});